import React, { useContext } from 'react';
import { CircularProgress, Box } from '@material-ui/core';
import { TreeItem, Skeleton } from '@material-ui/lab';
import { makeStyles } from '@material-ui/core/styles';
import { TreeContext } from './Tree';
import Error from '../Error';

const useStyles = makeStyles(theme => ({
  skelwrapper: {
    padding: '3px 0'
  },
  selectedNode: {
    backgroundColor: '#bdbdbd'
  }
}));

const TreePlaceholder = props => {
  const classes = useStyles();
  return props.childCount ? (
    Array(props.childCount)
      .fill()
      .map((_, i) => (
        <TreeItem
          key={i}
          nodeId={`${i}`}
          label={
            <Box className={classes.skelwrapper}>
              <Skeleton variant='rect' height={18} />
            </Box>
          }
        />
      ))
  ) : (
    <TreeItem nodeId='loading' label={<CircularProgress />} />
  );
};

const compareNodes = (a, b) => {
  // put items with children before items without
  // then sort by name

  if (a.childCount > 0 && b.childCount === 0) {
    return -1;
  }

  if (a.childCount === 0 && b.childCount > 0) {
    return 1;
  }

  return a.name.localeCompare(b.name);
};

const TreeNodes = props => {
  const classes = useStyles();
  const { loading, error, data } = props.queryResult;
  const path = props.path;
  const { ChildComponent, onItemSelected, selectedNodeId } = useContext(TreeContext);

  return (
    <>
      {loading && <TreePlaceholder {...props} />}
      {error && <Error />}
      {!loading &&
        !error &&
        data &&
        data.sort(compareNodes).map(node => {
          const nodePath = [...path, node];
          return (
            <TreeItem
              key={node.id}
              nodeId={node.id}
              label={
                <div className={selectedNodeId === node.id ? classes.selectedNode : null}>
                  {`${node.name}${node.metricCount > 0 ? ` (${node.metricCount})` : ''}`}
                </div>
              }
              onClick={() => node.metricCount > 0 && onItemSelected(nodePath, node.id)}
            >
              {node.childCount > 0 ? <ChildComponent id={node.id} name={node.name} childCount={node.childCount} path={nodePath} /> : null}
            </TreeItem>
          );
        })}
    </>
  );
};

export default TreeNodes;
